import styled from "styled-components"
import { device } from "../device"
import whiteBg from '../assets/images/white-bg.png'
import greenBook from '../assets/images/green-book.png'
import openBook from '../assets/images/open-book.png'
import teacher from '../assets/images/teacher.png'
import blueVector from '../assets/images/blue-vector.png'
import frameDots from '../assets/images/frame-dots.png'
import rainbowFrame from '../assets/images/rainbow-frame.png'
import star from '../assets/images/star.png'
import arrowCurvey from '../assets/images/arrow-curvey.png'
import vectorPhoto from '../assets/images/mask-group.png'

export const Container = styled.div `
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  padding-bottom: 80px;
  margin-bottom: 30px;
`;
export const BoxContainer = styled.div `
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  width: 100%;

  @media ${device.tablet} {

  }

  @media ${device.laptopM} {

  }
`;
export const CurlyBg = styled.div `
  display: none;

  @media ${device.tablet} {
    display: block;
    background-image: url(${whiteBg});
    background-repeat: no-repeat;
    background-size: contain;
    width: 100%;
    height: 340px;
    z-index: 1;
    margin-top: 100px;
  }

  @media ${device.laptopS} {
    top: -30px;
    height: 300px;
  }

  @media ${device.laptop} {
    top: -30px;
    height: 420px;
  }

  @media ${device.laptopM} {
    margin-top: 75px;
    top: -30px;
    height: 640px;
  }

  @media ${device.desktop} {
    top: -183px;
    height: 1140px;
  }

`;

export const ClassroomVector = styled.div `
  display: none;

  @media ${device.tablet}{
    display: block;
    background-image: url(${vectorPhoto});
    background-repeat: no-repeat;
    background-size: contain;
    width: 614px;
    height: 365px;
    z-index: 3;
    position: absolute;
    top: 0;
    right: -310px;
  }

  @media ${device.laptopM} {
    height: 560px;
    right: -148px;
  }
  @media ${device.desktop} {
    height: 831px;
    width: 768px;
    top: 17px;
    right: -83px;
  }
`;

export const Star = styled.div `
  align-self: center;
  background-image: url(${star});
  background-repeat: no-repeat;
  background-size: contain;
  margin-right: 100px;
  width: 20px;
  height: 20px; 

  @media ${device.laptop} {
   width: 35px;
   height: 35px;
  }

  @media ${device.desktop} {
   width: 55px;
   height: 55px;
  }
`;

export const ArrowCurvey = styled.div `
  background-image: url(${arrowCurvey});
  background-repeat: no-repeat;
  background-size: contain;
  width: 70px;
  height: 70px;
  position: absolute;
  top: 250px;

  @media ${device.mobileM} {
    left: 46px;
  }

  @media ${device.mobileL} {
    top: 275px;
    left: 75px;
  }

  @media ${device.mobileXL} {
    top: 280px;
  }

  @media ${device.tablet} {
    top: 350px;
    left: 95px;
  }
  
  @media ${device.laptopS} {
    top: 350px;
    left: 95px;
  }

  @media ${device.laptop} {
    top: 400px;
    left: 151px;
    width: 90px;
    height: 90px;
  }

  @media ${device.laptopM} {
    top: 480px;
    left: 310px;
  }

  @media ${device.desktop} {
    top: 780px;
    left: 650px;
    width: 180px;
    height: 120px;
  }
`;
export const Title = styled.h1`
  z-index: 5;
  position: relative;
  display: flex;
  flex-direction: column;
  font-family: 'Quicksand', sans-serif;
  font-size:25px;
  padding-left: 100px;
  margin-bottom: 10px;
  color: ${({ theme }) =>  theme.colors.darkPrimary};


  @media ${device.tablet} {
    font-size: 38px;
  }

  @media ${device.laptop} {
    font-size: 54px;
  }

  @media ${device.laptopM} {
    font-size: 69px;
  }

  @media ${device.laptopL} {
  }

  @media ${device.desktop} {
  }
`;

export const SubTitle = styled(Title)`
  font-size: 16px;
  margin-top: 5px;

  @media ${device.tablet} {
    font-size: 24px;
  }
  @media ${device.laptop} {
    font-size: 32px;
  }

  @media ${device.laptopM} {
    font-size: 38px;
    font-size: 30px;
    top: 550px;
    left: 250px;
    margin-top: 5px;
  }

  @media ${device.desktop} {
    font-size: 70px;
  }
`;

// export const Underline = styled.div `
//   background-image: url(${underlineTitle});
//   background-repeat: no-repeat;
//   background-size: contain;
//   width: 100%;
//   height: 221px;
//   /* position: absolute;
//   left: 57.01%;
//   right: 18.19%;
//   top: 16.15%;
//   bottom: 83.51%; */
// `;
export const Title2 = styled.h1`
  position: absolute;
  top: 330px;
  left: 30px;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-family: 'Quicksand', sans-serif;
  font-size: 30px;
  color: ${({ theme }) =>  theme.colors.darkPrimary};
  width: 85%;

  @media ${device.tablet} {
    flex-direction: row;
    width: 80%;
    font-size: 33px;
    top: 430px;
    left: 165px;
  }

  @media ${device.laptopS} {
    font-size: 33px;
    top: 430px;
  }

  @media ${device.laptop} {
    font-size: 48px;
    top: 480px;
  }

  @media ${device.laptopM} {
    top: 550px;
    font-size: 60px;
    left: 200px;
    width: 75%;
  }

  @media ${device.laptopL} {
    top: 625px;
  }

  @media ${device.desktop} {
    display: flex;
    align-items: center;
    top: 1220px;
    left: 400px;
    font-size: 120px;
  }
`;

export const SubTitle2 = styled(Title2)`
  display: none;

  @media ${device.laptopS} {
    display: block;
    font-size: 16px;
    width: 70%;
    top: 490px;
    left: 50px;
  }

  @media ${device.laptopS} {
    font-size: 16px;
    width: 70%;
    top: 490px;
    left: 50px;
  }

  @media ${device.laptop} {
    font-size: 24px;
    top: 560px;
    left: 50px;
  }

  @media ${device.laptopM} {
    top: 680px;
    left: 205px;
    font-size: 30px;
    width: 75%;
  }

  @media ${device.laptopL} {
    top: 730px;
  }

  @media ${device.desktop} {
    top: 1380px;
    left: 560px;
    font-size: 85px;
  }`;

export const SubTitle3 = styled(Title2)`
  display: none;

  @media ${device.tablet} {
    display: block;
    font-size: 16px;
    width: 70%;
    top: 490px;
    left: 400px;
  }
  
  @media ${device.laptopS} {
    font-size: 16px;
    width: 70%;
    top: 490px;
    left: 400px;
  }

  @media ${device.laptop} {
    font-size: 24px;
    top: 590px;
    left: 50px;
  }

  @media ${device.laptopM} {
    top: 715px;
    left: 205px;
    font-size: 30px;
    width: 75%;
  }

    @media ${device.laptopL} {
    top: 765px;
  }

  @media ${device.desktop} {
    top: 1380px;
    left: 560px;
    font-size: 85px;
  }`;
export const SubTitle4 = styled(Title2)`
  display: none;

  @media ${device.tablet} {
    display: block;
    font-size: 16px;
    width: 70%;
    top: 510px;
    left: 50px;
  }

  @media ${device.laptopS} {
    font-size: 16px;
    width: 70%;
    top: 510px;
    left: 50px;
  }

  @media ${device.laptop} {
    font-size: 24px;
    top: 560px;
    left: 500px;
  }

  @media ${device.laptopM} {
    top: 680px;
    left: 745px;
    font-size: 30px;
    width: 75%;
  }

  @media ${device.laptopL} {
    top: 730px;
  }

  @media ${device.desktop} {
    top: 1380px;
    left: 560px;
    font-size: 85px;
  }`;
export const SubTitle5 = styled(Title2)`
  display: none;

  @media ${device.tablet} {
    display: block;
    font-size: 16px;
    width: 70%;
    top: 510px;
    left: 400px;
  }

  @media ${device.laptopS} {
    font-size: 16px;
    width: 70%;
    top: 510px;
    left: 400px;
  }

  @media ${device.laptop} {
    font-size: 24px;
    top: 590px;
    left: 500px;
  }

  @media ${device.laptopM} {
    top: 715px;
    left: 725px;
    font-size: 30px;
    width: 75%;
  }

  @media ${device.laptopL} {
    top: 765px;
  }

  @media ${device.desktop} {
    top: 1380px;
    left: 560px;
    font-size: 85px;
  }`;

export const PrimaryColor = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  @media ${device.tablet} {
    margin-left: 10px;
  }
  @media ${device.laptopM} {
    margin-left: 15px;
  }

`;

export const Color = styled.span`
  color: ${({ theme }) =>  theme.colors.primary};
  font-family: 'Quicksand', sans-serif;
  font-size: 30px;
  margin: 0;

  @media ${device.tablet} {
    font-size: 33px;
    margin-left: 15px;
  }

  @media ${device.laptop} {
    font-size: 50px;
  }

  @media ${device.laptopM} {
    font-size: 76px;
  }

  @media ${device.desktop} {
    font-size: 130px;
  }
`;
export const InfoBox = styled.div `
  z-index: 5;
`;
export const TextInfoBox = styled.p`
  position: absolute;
  top: 450px;
  left: 20px;
  width: 90%;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  color: ${({ theme }) =>  theme.colors.darkPrimary};
  text-align: center;

  @media ${device.tablet} {
    top: 535px;
    font-size: 14px;
  }

  @media ${device.laptopS} {
    top: 550px;
    font-size: 14px;
  }

  @media ${device.laptop} {
    top: 650px;
    font-size: 18px;
  }

  @media ${device.laptopM} {
    top: 765px;
    font-size: 20px;
  }

  @media ${device.laptopL} {
    top: 850px;
    font-size: 22px;
  }

  @media ${device.desktop} {
    top: 1600px;
    font-size: 43px;
  }
`;
export const H5 = styled.h5 `
  color: ${({ theme }) =>  theme.colors.darkPrimary};
  font-size: 13px;
  margin: 0;
  margin-top: 10px;

  @media ${device.mobileM} {
    width: 85%;
    margin-top: 20px;
    margin-left: 40px;
  }

  @media ${device.mobileL} {
    margin-top: 50px;
    font-size: 16px;
  }

  @media ${device.tablet} {
    width: 60%;
    margin-top: 50px;
    margin-left: 40px;
    font-size: 22px;
  }

  @media ${device.laptopS} {
    width: 60%;
    margin-top: 50px;
    margin-left: 40px;
    font-size: 22px;
  }

  @media ${device.laptop} {
    font-size: 25px;
    margin-left: 50px;
  }
  @media ${device.laptopM} {
    font-size: 32px;
    margin-left: 50px;
  }
  @media ${device.desktop} {
    font-size: 50px;
  }
`;
export const Button = styled.button `
  background-color: ${({ theme }) =>  theme.colors.primary};
  color: ${({ theme }) =>  theme.colors.white};
  border-radius: 8px;
  border: none;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  width: 177px;
  height: 33px;
  cursor: pointer;
  font-family: 'Poppins', sans-serif;
  font-size: 11px;
  line-height: 18px;
  z-index: 3;
  position: absolute;
  top: 220px;
  left: 150px;
  /* top: 193px; */

  &:hover {
    background-color: ${({ theme }) =>  theme.colors.darkHover};
  }

  @media ${device.mobileM} {
    top: 260px;
    left: 170px;
  }

  @media ${device.mobileXL} {
    top: 260px;
    left: 160px;
  }

  @media ${device.tablet} {
    font-size: 14px;
    width: 223px;
    top: 320px;
    left: 180px;
  }
  
  @media ${device.laptopS} {
    top: 320px;
    left: 180px;
  }

  @media ${device.laptop} {
    font-size: 18px;
    width: 277px;
    height: 35px;
    top: 380px;
    left: 270px;
  }

  @media ${device.laptopM} {
    top: 424px;
    left: 420px;
  }

  @media ${device.desktop} {
    height: 65px;
    width: 380px;
    font-size: 26px;
    top: 680px;
    left: 790px;
  }

`;
export const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 626px;
  width: 80%;

  @media ${device.tablet} {
    margin-top: -330px;
  }

  @media ${device.laptop} {
    margin-top: 723px;
  }

  @media ${device.laptopM} {
    margin-top: 864px;
  }

  @media ${device.desktop} {
    margin-top: 65px;
  }
`;
export const H2 = styled.h2`
  font-family: 'Quicksand', sans-serif;
  font-size: 28px;
  color: ${({ theme }) =>  theme.colors.darkPrimary};
  text-align: center;
  margin-bottom: 0;
  z-index: 3;
  @media ${device.laptop} {
    font-size: 56px;
  }

  @media ${device.desktop} {
    font-size: 110px;
  }
`;
export const Text = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  color: ${({ theme }) =>  theme.colors.darkPrimary};
  text-align: center;

  @media ${device.tablet} {
    font-size: 14px;
  }

  @media ${device.laptop} {
    font-size: 18px;
  }

  @media ${device.desktop} {
    font-size: 34px;
  }
`;
export const Bold = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: ${({ theme }) =>  theme.colors.darkPrimary};
  text-align: center;

  @media ${device.desktop} {
    font-size: 34px;
  }
`;
export const InfoWrapper = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-top: 580px;

  @media ${device.mobileM} {
    margin-top: 550px;
  }

  @media ${device.mobileL} {
    margin-top: 500px;
  }

  @media ${device.tablet} {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    width: 100%;
    margin-top: 0;
  }

  @media ${device.laptopS} {
    margin-top: 100px;
  }

  @media ${device.laptop} {
    margin-top: 40px;
  }
`;
export const InfoCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 80%;

  margin-bottom: 12px;
  padding: 20px;
  background: ${({ theme }) =>  theme.colors.white};
  border-radius: 8px;
  box-shadow: 0px 0px 18px rgba(0, 0, 0, 0.25);
  z-index: 3;

  @media ${device.mobileL} {
    width: 300px;
  }

  @media ${device.tablet} {
    margin-right: 10px;
    height: 410px;
  }

  @media ${device.desktop} {
    width: 500px;
    height: 700px;
  }

`;
export const Titulo = styled.p`
  font-family: 'Quicksand', sans-serif;
  font-size: 16px;
  color: ${({ theme }) =>  theme.colors.darkPrimary};
  text-align: center;
  margin-bottom: 0;

  @media ${device.desktop} {
    font-size: 30px;
  }
`;
export const Information = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  color: ${({ theme }) =>  theme.colors.darkPrimary};
  text-align: center;

  @media ${device.desktop} {
    font-size: 20px;
  }
`;
export const BookIcon = styled.div `
  background-image: url(${greenBook});
  background-repeat: no-repeat;
  background-size: contain;
  width: 80px;
  height: 80px;

  @media ${device.desktop} {
    width: 120px;
    height: 120px;
  }
`;
export const OpenBookIcon = styled.div `
  background-image: url(${openBook});
  background-repeat: no-repeat;
  background-size: contain;
  width: 80px;
  height: 80px;

  @media ${device.desktop} {
    width: 120px;
    height: 120px;
  }
`;
export const TeacherIcon = styled.div `
  background-image: url(${teacher});
  background-repeat: no-repeat;
  background-size: contain;
  width: 80px;
  height: 80px;

  @media ${device.desktop} {
    width: 120px;
    height: 120px;
  }
`;
export const ButtonBottom = styled.button `
  background-color: ${({ theme }) =>  theme.colors.primary};
  color: ${({ theme }) =>  theme.colors.white};
  border-radius: 8px;
  border: none;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  width: 75%;
  height: 53px;
  cursor: pointer;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  line-height: 16px;
  z-index: 3;

  &:hover {
    background-color: ${({ theme }) =>  theme.colors.darkHover};
  }

  @media ${device.mobileM} {
    font-size: 18px;
  }

  @media ${device.mobileL} {
    width: 335px;
    font-size: 22px;
  }

  @media ${device.tablet} {
    margin-top: 20px;
  }

  @media ${device.laptopS} {
    margin-top: 18px;
    font-size: 18px;
    height: 40px;
  }

  @media ${device.desktop} {
    font-size: 24px;
    width: 390px;
    height: 65px;
  }
`;
export const BlueVectorIcon = styled.div `
  background-image: url(${blueVector});
  background-repeat: no-repeat;
  background-size: contain;
  width: 613.89px;
  height: 727.31px;
  position: absolute;
  left: -16.94%;
  left: 0;
  right: 74.31%;
  top: 58.23%;
  bottom: 6.31%;

  @media ${device.desktop} {
    top: 80.23%;
  }
`;
export const OrangeDots = styled.div `
  background-image: url(${frameDots});
  background-repeat: no-repeat;
  background-size: contain;
  width: 143px;
  height: 158px;
  position: absolute;
  left: -0.35%;
  right: 89.38%;
  top: 71.3%;
  bottom: 33.08%;
  z-index: 2;
`;
export const OrangeDotsTwo = styled.div `
  background-image: url(${frameDots});
  background-repeat: no-repeat;
  background-size: contain;
  width: 143px;
  height: 158px;
  position: absolute;
  left: -2.5%;
  right: 89.38%;
  top: 78.3%;
  bottom: 33.08%;
`;
export const RainbowIcon = styled.div `
  background-image: url(${rainbowFrame});
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  width: 480px;
  height: 371px;
  right: -205px;
  bottom: -25px;
`;


